import { CourseRun } from "@/common/courseRun/types";
import isCourseArchived from "@/lib/course/utils/isCourseArchived";
import { isDateInPast } from "@/lib/date";
import { useMonarchRule } from "@/monarch/rules/MonarchRulesProvider";
import type {
  InternalTrackSelectionData,
  InternalTrackSelectionTestResult,
  InternalTrackSelection,
  TrackSelectionVariant,
  InternalTrackSelectionPayload,
} from "@/monarch/rules/trackSelection/types";

const CUSTOM_RULE_ID = "internalTrackSelect";

const useInternalTrackSelect: InternalTrackSelection = (course) => {
  const { isLoading, value } = useMonarchRule<{
    data: InternalTrackSelectionData;
  }>(CUSTOM_RULE_ID, {
    courseModes: course?.activeCourseRun?.seats
      ?.map((seat) => seat?.type)
      .join(","),
    isCourseArchived: course?.activeCourseRun
      ? isCourseArchived(course?.activeCourseRun)
      : true,
    isCourseEnrollable: course?.activeCourseRun?.isEnrollable,
  });

  // If still loading or no value returned, return loading state
  if (isLoading || !value) {
    return {
      isLoading,
    } as InternalTrackSelectionTestResult;
  }

  // Return the experiment result with proper typing
  return {
    isLoading: false,
    variant:
      value.data.useInternalTrackSelection === "true" ? "test" : "control",
    data: value.data,
  };
};

export default useInternalTrackSelect;
